import { IHistoryDevice } from '../../../interfaces';
import {
    GET_HISTORY_DEVICE,
    GET_HISTORY_DEVICE_SUCCESS,
    GET_HISTORY_DEVICE_ERROR,
  } from '../../../constants/historyDevice';
  
  interface IGetDeviceReducer {
    data: IHistoryDevice[],
    loading: boolean, 
    error: null
  }
  
  export const getHistoryDeviceIS: IGetDeviceReducer = {data: [], loading: false, error: null}

  interface IGetHistoryDeviceAction {
    type: typeof GET_HISTORY_DEVICE
  }

  interface IGetHistoryDeviceActionSuccess {
    type: typeof GET_HISTORY_DEVICE_SUCCESS,
    payload: any[]
  }

  interface IGetHistoryDeviceActionError {
    type: typeof GET_HISTORY_DEVICE_ERROR;
    error: string
  }

  type GetHistoryDeviceActions = IGetHistoryDeviceAction | IGetHistoryDeviceActionSuccess | IGetHistoryDeviceActionError

  export const getHistoryDevice = (state: IGetDeviceReducer = getHistoryDeviceIS, actions: GetHistoryDeviceActions): IGetDeviceReducer => {
    switch (actions.type) {
      case GET_HISTORY_DEVICE:
        return {
          ...state,
          loading: true,
        };
      case GET_HISTORY_DEVICE_SUCCESS:
        return {
          data: actions.payload,
          loading: false,
          error: null,
        };
      case GET_HISTORY_DEVICE_ERROR:
        return {
          ...state,
          loading: false,
          error: null,
        };
      default:
        return state;
    }
  };
  